import { useContext, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { LanguageContext } from './LanguageContext';

function PrivacyPolicy() {
    const {textContent, language } = useContext(LanguageContext);

    // Update document title for privacy page based on language
    useEffect(() => {
        if (textContent && textContent.companyName && textContent.PrivacyPolicy) {
            setTimeout(() => {
                document.title = `${textContent.companyName} | ${textContent.PrivacyPolicy}`;
            }, 0);
        }

        if (language === 'th') {
            document.title = `บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด | นโยบายความเป็นส่วนตัว`;
        } else {
            document.title = `AI Business Technology Co., Ltd. | Privacy Policy`;
        }
    }, [textContent, language]);

    return (
        <div className="bg-gray-100 min-h-screen">
            <Header />

            <main className="container mx-auto px-4 py-8">
                {language === 'th' ? (
                    <>
                        <h1 className="text-4xl font-bold mb-10 text-center">นโยบายความเป็นส่วนตัว</h1>
                        <p className="text-gray-700 mb-4">
                            <b>บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด</b> (“บริษัท”) ให้ความสำคัญอย่างยิ่งต่อการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการทุกท่าน ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 บริษัทจึงขอชี้แจงนโยบายคุ้มครองข้อมูลส่วนบุคคล ดังนี้:
                        </p>

                        <h2 className="text-2xl font-bold mb-2">1. ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม</h2>
                        <p className="text-gray-700 mb-4">
                            บริษัทมีการรวบรวมและจัดเก็บข้อมูลส่วนบุคคลของท่านในกรณีต่อไปนี้:
                        </p>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li><b>การติดต่อสอบถามข้อมูล:</b> ชื่อ-นามสกุล และอีเมล</li>
                            <li><b>การสมัครอบรมหลักสูตรด้าน IT:</b> ชื่อ-นามสกุล, อีเมล, เบอร์โทรศัพท์, และตำแหน่งงาน (รวมถึงที่อยู่และเลขประจำตัวประชาชนในกรณีที่ขอใบกำกับภาษี)</li>
                            <li><b>การเข้าเยี่ยมชมเว็บไซต์:</b>&nbsp; เก็บข้อมูลผ่านเครื่องมือวิเคราะห์พฤติกรรมการใช้งานเว็บไซต์และคุกกี้ 
                                (ดูเพิ่มเติมที่ <a href="https://www.aibusiness.co.th/cookie-policy" rel="noopener noreferrer"><span className='underline decoration-dotted'>นโยบายการใช้คุกกี้</span></a>) 
                            </li>                            
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">2. วัตถุประสงค์ในการเก็บรวบรวมข้อมูล</h2>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li>เพื่อติดต่อกลับในการตอบข้อซักถามหรือข้อเสนอแนะ</li>
                            <li>เพื่อจัดการการลงทะเบียนเข้าร่วมอบรมหลักสูตรด้าน IT</li>                                                        
                            <li>เพื่อปรับปรุงประสิทธิภาพและประสบการณ์ใช้งานเว็บไซต์ ผ่านการวิเคราะห์ข้อมูลเชิงสถิติและคุกกี้</li>
                            {/* <li>เพื่อส่งข้อมูลข่าวสาร กิจกรรม หรือหลักสูตรใหม่ ๆ ของบริษัท (กรณีที่ท่านยินยอม)</li> */}
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">3. การเปิดเผยข้อมูลส่วนบุคคล</h2>
                        <p className="text-gray-700 mb-4">
                            บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอก เว้นแต่:
                        </p>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li>เพื่อเป็นความยินยอมของเจ้าของข้อมูล</li>
                            <li>เพื่อให้เป็นไปตามกฎหมายหรือคำสั่งของศาล/หน่วยงานรัฐ</li>
                            <li>เพื่อผู้ให้บริการบุคคลที่สาม ได้แก่ ระบบคลาวด์ และ เครื่องมือวิเคราะห์ข้อมูล</li>
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">4. การเก็บรักษาความปลอดภัยของข้อมูล</h2>
                        <p className="text-gray-700 mb-4">
                            บริษัทดำเนินการตามมาตรการด้านเทคนิคและองค์กรที่เหมาะสม เพื่อปกป้องข้อมูลส่วนบุคคลของท่านจากการเข้าถึง แก้ไข ใช้ หรือเปิดเผยโดยไม่ได้รับอนุญาต
                        </p>

                        <h2 className="text-2xl font-bold mb-2">5. สิทธิของเจ้าของข้อมูลส่วนบุคคล</h2>
                        <p className="text-gray-700 mb-4">
                            ท่านมีสิทธิ ดังนี้:
                        </p>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                        <li>สิทธิในการขอให้แก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง</li>
                        <li>สิทธิในการลบหรือทำลาย</li>
                        <li>สิทธิการขอให้โอนข้อมูลส่วนบุคคล</li>
                        <li>สิทธิขอให้ระงับการประมวลผลข้อมูลส่วนบุคคล</li>
                        <li>สิทธิการคัดค้านการประมวลผลข้อมูลส่วนบุคคล</li>
                        <li>สิทธิในการเพิกถอนความยินยอม</li>
                        <li>สิทธิในการเพิกถอนความยินยอม</li>
                        </ul>
                        <p className="text-gray-700 mb-4">
                            ท่านสามารถใช้สิทธิดังกล่าวได้โดยติดต่อบริษัทตามช่องทางด้านล่าง
                        </p>

                        <h2 className="text-2xl font-bold mb-2">6. การติดต่อบริษัท</h2>
                        <p className="text-gray-700 mb-4">
                            หากท่านมีข้อสงสัย หรือประสงค์จะใช้สิทธิใด ๆ เกี่ยวกับข้อมูลส่วนบุคคล กรุณาติดต่อ:
                        </p>
                        <p className="text-gray-700 mb-4">
                            <b>บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด</b><br />
                            อีเมล: <span className='underline decoration-dotted'>info@aibusiness.co.th</span><br />                            
                            โทรศัพท์: 061-253-0020
                        </p>
                    </>
                ) : (
                    <>
                        <h1 className="text-4xl font-bold mb-10 text-center">Privacy Policy</h1>
                        <p className="text-gray-700 mb-4">
                            AI Business Technology Co., Ltd. (“Company”) values the protection of personal data of all users. In accordance with the Personal Data Protection Act (PDPA) B.E. 2562, the Company provides the following privacy policy:
                        </p>

                        <h2 className="text-2xl font-bold mb-2">1. Personal Data Collected</h2>
                        <p className="text-gray-700 mb-4">
                            The Company collects and stores your personal data in the following cases:
                        </p>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li><b>Contact inquiries:</b> Name and email</li>
                            <li><b>IT training registration:</b> Name, email, phone number, position (including address and national ID if requesting a tax invoice)</li>
                            <li><b>Website visits:</b> Collect data through website analytics tools and cookies
                                (See more at <a href="https://www.aibusiness.co.th/cookie-policy" rel="noopener noreferrer"><span className='underline decoration-dotted'>Cookie Policy</span></a>) 
                            </li>
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">2. Purpose of Data Collection</h2>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li>To respond to inquiries or feedback</li>
                            <li>To manage IT training registration</li>
                            <li>To improve website performance and user experience through statistical analysis and cookies</li>
                            {/* <li>To send news, activities, or new courses (with consent)</li> */}
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">3. Disclosure of Personal Data</h2>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li>To the data subject’s consent</li>
                            <li>To compliance with law or court/government orders</li>                        
                            <li>To third-party service providers, i.e., cloud services and analytics tools</li>
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">4. Data Security</h2>
                        <p className="text-gray-700 mb-4">
                            The Company applies appropriate technical and organizational measures to protect personal data from unauthorized access, alteration, use, or disclosure.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">5. Data Subject Rights</h2>
                        <p className="text-gray-700 mb-4">
                            You have the following rights:
                        </p>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li>Right of access</li>
                            <li>Right of rectification</li>
                            <li>Right to erasure / Right to be forgotten</li>
                            <li>Right to data portability</li>
                            <li>Right to restrict processing</li>
                            <li>Right to object</li>
                            <li>Right to Withdraw Consent</li>
                        </ul>
                        <p className="text-gray-700 mb-4">
                            You can exercise these rights by contacting the Company through the channels below.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">6. Contact Information</h2>
                        <p className="text-gray-700 mb-4">
                            If you have any questions or wish to exercise any rights regarding your personal data, please contact:
                        </p>
                        <p className="text-gray-700 mb-4">
                            <b>AI Business Technology Co., Ltd.</b><br />
                            Email: <span className='underline decoration-dotted'>info@aibusiness.co.th</span><br />
                            Phone: 061-253-0020
                        </p>
                    </>
                )}
            </main>

            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
